import type { AreaSummary } from './types'

export interface AreaCascadeLevel {
  options: AreaSummary[]
  value: string
  parent: AreaSummary | null
}

export function buildAreaCascadeLevels(
  areas: AreaSummary[],
  areaPath: string[],
): AreaCascadeLevel[] {
  const levels: AreaCascadeLevel[] = []
  let parent: AreaSummary | null = null

  for (let index = 0; ; index += 1) {
    const parentId: string | null = parent?.id ?? null
    const options: AreaSummary[] = areas.filter((area: AreaSummary) => area.parentId === parentId)
    if (!options.length) break

    const value = areaPath[index] ?? ''
    levels.push({ options, value, parent })
    if (!value) break

    const selected: AreaSummary | undefined = options.find((area: AreaSummary) => area.id === value)
    if (!selected) break
    parent = selected
  }

  return levels
}
